"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateBasketItemErrorResponse = exports.UpdateBasketItemFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-basket-item-failed';
const UpdateBasketItemFailedEvent = exports.UpdateBasketItemFailedEvent = Name;
const isUpdateBasketItemErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdateBasketItemErrorResponse = isUpdateBasketItemErrorResponse;
